import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from "../_services/auth.service";
import {inject} from "@angular/core";

export const authGuard: CanActivateFn = (_, state) => {
    const user = inject(AuthService).userValue;

    if (!user) {
        inject(Router).navigate(['/account/login'], {queryParams: {returnUrl: state.url}}).then();
        return false;
    }

    if (!user.roles!.includes("VineMedsAdmin")) {
        inject(Router).navigate(['/account/login'], {queryParams: {returnUrl: state.url}}).then();
        return false;
    }

    return true;
};
